module.exports = __webpack_public_path__ + "media/images/header-bg-2-2872d22a.png";